// @flow
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import glamorous from "glamorous";
import { createStructuredSelector } from "reselect";
import { debounce } from "lodash";
import { UPLOAD_SOURCES } from "@cld/upload-widget";
import TabHeader from "root/components/TabHeader";
import t from "common/i18n";
import consts from "../../data/consts";
import {
	selectMediaType,
	selectSearchTermText,
	selectUserName,
	selectSelectedItems,
	selectFiltersPanelOpen,
	selectFiltersChanged,
} from "../../selectors";
import bindActions, { types as ats } from "../../actions";
import TabHeaderButtons from "../../../common/components/TabHeaderButtons";

type OwnProps = {|
	showSearch: boolean,
	hasSearchTerm: boolean,
	isInPurchase: boolean,
	onLogout: Function,
	onBackNavigation: Function,
	doSearch: Function,
	clearSearchTerm: Function,
	clearSearchFilters: Function,
|};

type Props = {
	...OwnProps,
	showSearch: boolean,
	hasSearchTerm: boolean,
	isInPurchase: boolean,
	onLogout: Function,
	onBackNavigation: Function,
	doSearch: Function,
	clearSearchTerm: Function,
	clearSearchFilters: Function,
	userName: ?string,
	mediaType: string,
	searchTermText: string,
	selectedItems: Object[],
	isFiltersPanelOpen: boolean,
	didFiltersChange: boolean,
	actions: { [string]: Function },
};

const MEDIA_TYPES_VALUES = Object.values(consts.MEDIA_TYPES);

const { SHUTTERSTOCK } = UPLOAD_SOURCES;

const GHeaderContent = glamorous.div(cx("flex justify-content-between", "h-100"));

export const Header = (props: Props) => {
	const { actions, showSearch } = props;

	const onSearch = () => {
		props.doSearch({ searchTerm: props.searchTermText });
	};

	const onSearchTermChange = debounce((term: string) => {
		actions[ats.SET_SEARCH_TERM_TEXT]({ term });
	}, 50, { leading: true });

	const onMediaTypeChange = (option: { value: string }) => {
		props.doSearch({ mediaType: option.value });
	};

	const mediaTypes = MEDIA_TYPES_VALUES.map((value: any): any => ({
		label: t(`shutterstock.media_types.${value}`),
		value
	}));

	const selectedMediaType = showSearch
		? (mediaTypes.find((type) => type.value === props.mediaType) || {}).label : null;

	const title = props.isInPurchase
	&& props.selectedItems.length
		? props.selectedItems[0].subtitle : null;

	return <TabHeader
		source={UPLOAD_SOURCES.SHUTTERSTOCK}
		showSearch={showSearch}
		expandSearch
		hideBackButton
		searchTerm={props.searchTermText}
		searchTermHandler={onSearchTermChange}
		clearBtnTip={t("shutterstock.search.reset")}
		showClearButton={props.hasSearchTerm}
		onClearClickHandler={props.clearSearchTerm}
		searchClickHandler={onSearch}
		searchOptions={mediaTypes}
		selectedSearchOption={selectedMediaType}
		searchOptionHandler={onMediaTypeChange}
		userName={props.userName}
		onLogout={props.onLogout}
		onBackNavigation={props.onBackNavigation}
		searchInputPlaceholder={t("shutterstock.search.placeholder")}
		showBackButton={props.isInPurchase}
		titleCenter={title}>
		{showSearch
		&& <GHeaderContent>
			<TabHeaderButtons
				id={SHUTTERSTOCK}
				routes={consts.ROUTES}
				searchTerm={props.searchTermText}
				clearSearchTerm={() => props.clearSearchTerm()}
				isFiltersPanelOpen={props.isFiltersPanelOpen}
				showIndicator={!props.isFiltersPanelOpen && props.didFiltersChange}
				toggleFilterPanel={() => actions[ats.TOGGLE_FILTERS_PANEL]()}
			/>
		</GHeaderContent>}
	</TabHeader>;
};

export default connect<Props, OwnProps, _, _, _, _>(
	createStructuredSelector({
		userName: selectUserName,
		mediaType: selectMediaType,
		searchTermText: selectSearchTermText,
		selectedItems: selectSelectedItems,
		isFiltersPanelOpen: selectFiltersPanelOpen,
		didFiltersChange: selectFiltersChanged,
	}),
	(dispatch: Function) => ({
		actions: bindActions(dispatch),
	}),
)(Header);
